export const DOMAINE_RESET = "DOMAINE_RESET";
export const DOMAINE_SET_ERROR = "DOMAINE_SET_ERROR";
export const DOMAINE_SET_ITEMS = "DOMAINE_SET_ITEMS";
export const DOMAINE_TOGGLE_LOADING = "DOMAINE_TOGGLE_LOADING";
